import React, { useEffect, useState } from "preact/compat";
import { CloseOutlined } from "@ant-design/icons";

export interface Props {
  content: string;
}

export default function NoticeBanner({ content }: Props) {

  const [showBanner, setShowBanner] = useState(true);

  function onClose(ev: any) {
    ev.stopPropagation();
    setShowBanner(false);
  }

  return (
    showBanner && <div className="notice-banner">
      <div className="banner-content" dangerouslySetInnerHTML={{ __html: content }} />
      <div className="close-btn" onClick={(ev) => onClose(ev)}><CloseOutlined /></div>
    </div>
  );
}
